import { render, staticRenderFns } from "./Create-Request-Po.vue?vue&type=template&id=48f8f52c"
import script from "./Create-Request-Po.vue?vue&type=script&lang=js"
export * from "./Create-Request-Po.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports